import React, { useState } from 'react';
import styles from './offerConfigurationReview.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../shared/customButton';
import { addCVFilterStep, addCVReviewStep, addExternalAssessmentStep } from '../../../../../services/util/hiringpipeline/steps';
import { submitOffer, editOffer } from '../../../../../services/util/offerHandling';

const Review = (props) => {
    const [state, setState] = useState(false);

    const submitDetails = async () => {
        setState(true)

        let reviwersArray = [];
        await (props.values.offerReviewers).forEach(element => {
            reviwersArray.push(element._id)
        });

        let respond ;
        if(props.values.candidateID){
            respond= await submitOffer(props.values.candidateID, props.values.jobTitle,props.values.allocation,props.values.offerDescription,reviwersArray,props.values.packageReference);
            props.GetTaskValues();
        }
        else {
            respond = await editOffer(props.values.offerSessionId, props.values.jobTitle, props.values.allocation, props.values.offerDescription, reviwersArray, props.values.packageReference);
            props.GetTaskValues();
        }

        if (respond.success === true) {
            setState(false)
            props.refreshData();
            props.handleClose();
        }
        else {
            setState(false)
        }
    }

    return (
        <div>
            <Container >
                <Row className={styles.pipelineTopicRow}>
                    <Col className={styles.stepSubtopicName}>
                            Review
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Job&nbsp;Title&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.jobTitle}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Allocation&nbsp;Type&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.allocation ? props.values.allocation : 'No Allocation'}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Description&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.offerDescription ? props.values.offerDescription : 'No Description'}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Package&nbsp;Reference&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.packageReference ? props.values.packageReference : 'No Package Reference '}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                        <span className={styles.rowValues}>
                            {props.values.offerReviewers.map((value, index) => (
                                <p className="mb-1" key={index}><i className="fas fa-circle"></i>&nbsp;{value.email}&nbsp;-&nbsp;{value.first_name + ' ' + value.last_name}</p>
                            ))
                            }
                        </span>
                    </Col>
                </Row>



                <Row className={styles.actionBtns}>
                    <Col className="pl-0">
                        {<CustomButton
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}

                        />}
                    </Col>
                    <Col className="pr-0">
                        {<CustomButton
                            buttonType="submit"
                            label="Submit"
                            type="primaryBtn"
                            disabled={state === true ? true : false}
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            handleClick={() => submitDetails()}
                        />}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Review;
